<template>
  <div class="ball-img" @click="startMake(true)">
    <img src="/static/images/mobile/ball.png?v=1">
  </div>
</template>

<script>
import { utils } from "../utils";
import { BaseUrl } from "../utils/config.js";
export default {
  data() {
    return {
      downUrl: "",
      qqShow: false,
      wechatShow: false,
      install: {},
      browser: {}
    };
  },
  mounted() {
    this.browser = utils.Browser;
    this.init();
  },
  methods: {
    init() {
      this.axios.install().then((res) => {
        this.install = res.data.data;
      })
    },
    startMake(bool) {
      const ua = navigator.userAgent.toLowerCase();
      if (utils.Browser.android) { // 安卓
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {   // 微信
          if (bool) {
            this.isAndroid = true;
          }
        } else {
          this.axios.install().then((res) => {
            this.downloadUrl = res.data.data
            window.location.href = this.downloadUrl.DownloadUrl
          })
        }
      } else if (utils.Browser.ios || utils.Browser.ipad || utils.Browser.iphone) {
        if (bool) {
          if (ua.match(/MicroMessenger/i) == 'micromessenger' || ua.indexOf(' qq') > -1 && ua.indexOf('mqqbrowser') < 0) { // 微信
            this.$router.push({
              path: '/install'
            })
          } else {
            //添加主屏幕
            window.location.href = BaseUrl + 'ios/wapenter?url=' + window.location.href + '&t=' + new Date().getTime();
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ball-img {
  position: fixed;
  bottom: 20px;
  left: 0;
  width: 750px;
  height: 156px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 690px;
    height: 156px;
  }
}
</style>
